import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { JobExtensionCompletedProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/JobExtensionCompletedProgressionActions'

export interface JobExtensionCompletedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}

export const JobExtensionCompletedProgressionActionsContainer = observer(
  function JobExtensionCompletedProgressionActionsContainer({
    vm,
    canCompleteJob,
  }: JobExtensionCompletedProgressionActionsContainerProps) {
    return (
      <JobExtensionCompletedProgressionActions
        isExtensionRejected={vm.isExtensionRejected}
        submittedExtensionConfirmationRejection={
          vm.submittedExtensionConfirmationRejection
        }
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        canCompleteJob={canCompleteJob}
        onUploadRejectionConfirmation={vm.viewExtensionDocumentCreationModal}
        onCompleteJob={vm.closeJob}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} />
          )
        }
      />
    )
  },
)
